module.exports = __webpack_public_path__ + "06_medium_gray.213f5214.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_medium_gray.png
// module id = l3KI
// module chunks = 0